module.exports = __webpack_public_path__ + "img/img7.bd2decf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img7.jpg
// module id = 302
// module chunks = 0